//  Copyright 2023
//  Myriota Pty Ltd
//  Myriota Confidential

import * as _ from "lodash";
import { Colours as MyColours } from "myriota-common/constant";
import { AdvancedThemeObject } from "redoc/typings/theme";

// common styles
export const REDOC_THEME: AdvancedThemeObject<any> = {
    colors: {
        primary: {
            main: MyColours.BLUE_100
        }
    },
    sidebar: {
        width: "300px",
        textColor: MyColours.BLACK_100,
        backgroundColor: MyColours.BLACK_10,
    },
    rightPanel: {
        backgroundColor: MyColours.LIGHT_GREY_100,
        fontFamily: "GTWalsheimRegular, Arial",
    },
    typography: {
        fontFamily: "GTWalsheimRegular, Arial",
        headings: {
            fontFamily: "GTWalsheimBold, Arial",
            fontWeight: "bold",
            lineHeight: "1em"
        },
        fieldName: {
            fontFamily: "GTWalsheimBold, Arial"
        },
        code: {
            fontFamily: "GTWalsheimBold, Arial",
            fontWeight: "600",
            wrap: true,
            color: MyColours.BLACK_100
        }
    },
    codeBlock: {
        color: MyColours.BLACK_100,
        tokens: {
            fontFamily: "GTWalsheimBold, Arial",
        }
    },
};
